import { render, staticRenderFns } from "./ResumenDeAvls.vue?vue&type=template&id=2779b9f0&scoped=true"
import script from "./ResumenDeAvls.vue?vue&type=script&lang=js"
export * from "./ResumenDeAvls.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2779b9f0",
  null
  
)

export default component.exports